import axiosConfig from "./axiosConfig";

export interface CoveredRange {
  start: string;
  end: string;
}

export interface OrientationCoverage {
  tilt: number;
  azimuth: number;
  covered_ranges: CoveredRange[];
  gaps: CoveredRange[];
}

export interface WeatherActualsCoverageResponse {
  overall_start: string | null;
  overall_end: string | null;
  has_gaps: boolean;
  gaps: CoveredRange[];
  orientations: OrientationCoverage[];
}

const getSiteWeatherActualsCoverage = async (
  authToken: string,
  siteId: string
): Promise<WeatherActualsCoverageResponse> => {
  const { data } = await axiosConfig.get(
    `/site/${siteId}/weather-actuals/coverage`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default getSiteWeatherActualsCoverage;
